export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/shield.c89ab940.svg","height":20,"width":19,"blurWidth":0,"blurHeight":0};